import { IS_WEB } from "@common/utils/mobileUtils"

// Props for the container of a list that opens under a search input and closes
// when that input blurs. On the web the browser moves the focus at `mousedown`,
// but react-native-web fires `onPress` only at `click`: a click held past the
// close delay would release on a row already gone. Cancelling the mousedown
// keeps the input focused until the row's `onPress` — which must therefore
// hand the focus back itself (`Keyboard.dismiss()`), or the input stays
// focused under a closed list and a click on it no longer reopens it.
export const keepInputFocusOnPress = IS_WEB
    ? { onMouseDown: (event) => event.preventDefault() }
    : {}
